export default {
  primary: {
    backgroundColor: 'transparent',
    padding: '1rem 2rem',
    color: 'white',
    borderBottom: 'solid 2px',
    transition: 'all ease-in-out 0.7s',
    backgroundSize: '100% 204%',
    backgroundColor: 'transparent',
    // backgroundImage: 'linear-gradient(to bottom,rgba(0,0,0,0) 50%,#579c3b 50%)',
    borderColor: 'tertiary',
    fontFamily: 'heading',
    fontWeight: 'normal',
    ':hover': {
      backgroundColor: 'primary',
      backgroundPosition: '0% -98%',
      color: 'white'
    }
  },
  secondary: {
    backgroundColor: 'transparent',
    color: 'dark',
    borderBottom: 'solid 2px',
    transition: 'all ease-in-out 0.7s',
    backgroundSize: '100% 204%',
    backgroundColor: 'transparent',
    // backgroundImage: 'linear-gradient(to bottom,rgba(0,0,0,0) 50%,#d01f31 50%)',
    borderColor: 'primary',
    padding: '0.5rem 1.5rem',
    fontFamily: 'heading',
    fontWeight: 'normal',
    ':hover': {
      backgroundColor: 'transparent',
      backgroundPosition: '0% -98%',
      color: 'light'
    }
  }
}
